<template>
    <div>
        <h4 class="title is-4">
            Welcome {{ $meta.userName }}
        </h4>

        <h6 class="subtitle is-6">
            Thank you for using our Portal.
        </h6>

        <p v-html="$meta.welcome_text"></p>

        <b-button
            v-if="$meta.features.contact_details"
            rounded
            @click="isContactModalActive = true"
        >
            Contact us
            <b-icon
                icon="arrow-right"
                size="is-small"
                class="ml-0"
            />
        </b-button>

        <ContactModal />
    </div>
</template>

<script>
import ContactModal from './ContactModal';

export default {
    components: {
        ContactModal,
    },

    data: function() {
        return {
            isContactModalActive: false,
        };
    },
};
</script>
